export const AUXILIARY_OPTIONS = {
    IGNORE_APPORTIONMENT: 1,
    FLAG_CLOCKING_NOT_TREATED: 2
}